import React from 'react';
import PropTypes from 'prop-types';
import {GelDragDropContext} from '../GelDragDrop.utils';

const cellRef = React.createRef();
const MIN_ROTATE_WIDTH_VALue = 65;

export function LabelCell(props) {
  const [ariaLabel, setAriaLabel] = React.useState();

  React.useEffect(() => {
    {
      props.headingAriaLabel
        ? renderAriaLabel(props.headingAriaLabel, props.label)
        : null;
    }
  }, [JSON.stringify(props.headingAriaLabel)]);

  let style = {height: '32px'};

  if (cellRef.current) {
    const {clientWidth} = cellRef.current;
    if (clientWidth < MIN_ROTATE_WIDTH_VALue) {
      style = {
        transform: 'rotateZ(90deg)',
        height: '90px',
      };
    }
  }

  const renderAriaLabel = (headingAriaLabel, cellLabel) => {
    if (headingAriaLabel.length !== 0) {
      headingAriaLabel.map((list) => {
        if (list.label === cellLabel) {
          function renderAirialabel() {
            if (typeof list.ariaLabel === 'object') {
              if (list.ariaLabel.gelBand2 === undefined) {
                const ariaLabel = `"Lane ${cellLabel}, ${list.ariaLabel.gelBand1}`;
                return ariaLabel;
              } else {
                const ariaLabel = `Lane ${cellLabel}, ${list.ariaLabel.gelBand1},${list.ariaLabel.gelBand2}`;
                return ariaLabel;
              }
            } else {
              const ariaLabel = `Lane ${cellLabel}, ${list.ariaLabel}`;
              return ariaLabel;
            }
          }
          return setAriaLabel(renderAirialabel);
        }
      });
    } else {
      return null;
    }
  };

  return (
    <div
      ref={cellRef}
      style={style}
      className={props.className}
      tabIndex={props.tabIndex}
      aria-label={ariaLabel}>
      <p className={`${props.className}__label`}>{props.label}</p>
    </div>
  );
}

LabelCell.propTypes = {
  /**
   * ClassName to be set for the cell;
   */
  className: PropTypes.string,
  /**
   * Label to dispaly on the cel
   */
  label: PropTypes.string,
  /**
   * AriaLabel of the heading
   */
  headingAriaLabel: PropTypes.shape({
    /**
     * Unique key for the data
     */
    key: PropTypes.number,
    /**
     * Label of the Heading
     */
    label: PropTypes.string,
    /**
     * Arialabel to display on the heading
     */
    ariaLabel: PropTypes.string,
    /**
     * Tabindex value passed from outside the component for keyboard navigation
     */
    tabIndex: PropTypes.number,
  }),
};

LabelCell.defaultProps = {tabIndex: 0};
